import { Injectable } from '@angular/core';
import { HttpParameterCodec } from '@angular/common/http';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class CaseService {
  private apiUrl = '/cases';
  private apiSpringUrl = '/spring/cases';

  constructor(private http: HttpService) { }

  get(): Promise<any> {
    const url = environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl;
    return this.http.get(url);
  }

  post(
    caseCd: string,
    caseTx: string,
    updprogramCd: string
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
    const jsonInput = {
      caseCd: caseCd,
      caseTx: caseTx,
      updprogramCd: updprogramCd
    };

    return this.http.post(url, jsonInput);
  }

  put(
    caseCd: string,
    caseTx: string,
    updcounterNr: number,
    updprogramCd: string
  ): Promise<any> {
    //ケースコード SW-2523
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/edit?caseCd=${encodeURIComponent(caseCd)}`;
    const jsonInput = {
      caseTx: caseTx,
      updcounterNr: updcounterNr,
      updprogramCd: updprogramCd
    };

    return this.http.put(url, jsonInput);
  }

  delete(
    caseCd: string,
  ): Promise<any> {
    const url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}/delete?caseCd=${encodeURIComponent(caseCd)}`;
    return this.http.delete(url);
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/case/case.service.ts